var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-sm leading-5 ptb-12 td-data",class:_vm.fixed ? ("fixed-" + _vm.fixed + "-column") : ''},[_c('div',{staticClass:"column-cell"},[_c('span',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }